import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';
import { ApiUrlHelper } from '../common/apiUrlHelper';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  constructor(private http: HttpClient,private apiUrl:ApiUrlHelper) { }

  downloadExcelFile(): void {
    const fileUrl = environment.ApiUrl + this.apiUrl.apiUrl.student.Template;
    const fileName = 'Upload_student.xlsx';

    this.http.get(fileUrl, { responseType: 'blob' })
      .subscribe((blob: Blob) => {
        saveAs(blob, fileName);
      });
  }
  downloadQuestionExcelFile(): void {
    const fileUrl = environment.ApiUrl + this.apiUrl.apiUrl.question.Template;
    const fileName = 'Upload_question.xlsx';

    this.http.get(fileUrl, { responseType: 'blob' })
      .subscribe((blob: Blob) => {
        saveAs(blob, fileName);
      });
  }
}